export default {
  rules: {
    selected: [(v) => !!v || 'Item is required'],
    required: value => !!value || 'Required.',
    not_zero: value => value != null || 'Required.',
    less_than_zero: value => value > 0 || 'Required.',
    eq_less_than_zero: value => value >= 0 || 'Required.',
    counter: value => value.length <= 20 || 'Max 20 characters',
    min: value => value.length <= 6 || 'Min 6 characters',
    email: value => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value) || 'Invalid e-mail.'
    },
    confirmPassword: (password, rePassword) => {
      return () => (password === rePassword) || 'Password must match'
    },
  },
}
